// extracted by mini-css-extract-plugin
export default {"container":"Method_container__Mpd-1","topBar":"Method_topBar__7m12q","button":"Method_button__TU9TH","content":"Method_content__91B8z"};